import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { contact, whatsappUrl } from '../content/siteContent';
import MapBackground from './decor/MapBackground';
import RoutePath from './decor/RoutePath';

const { FiArrowUpRight, FiMessageCircle, FiMapPin } = FiIcons;

function FinalCta() {
  return (
    <section className="final-cta">
      <div className="container final-cta__card">
        <MapBackground className="final-cta__map" />
        <RoutePath className="final-cta__route" />
        <span className="final-cta__pin"><SafeIcon icon={FiMapPin} /></span>
        <div className="final-cta__content">
          <span className="eyebrow eyebrow--dark">No salgas. Mándanos a nosotros.</span>
          <h2>¿Tienes un mandao?</h2>
          <p>Dinos qué necesitas y nosotros resolvemos.</p>
          <div className="final-cta__actions">
            <a className="button button--dark button--large" href={whatsappUrl()} target="_blank" rel="noreferrer">
              Pedir ahora <SafeIcon icon={FiArrowUpRight} />
            </a>
            <a className="button button--ghost-dark button--large" href={whatsappUrl()} target="_blank" rel="noreferrer">
              <SafeIcon icon={FiMessageCircle} /> Hablar por WhatsApp
            </a>
          </div>
          <strong className="final-cta__phone">{contact.phoneDisplay}</strong>
        </div>
      </div>
    </section>
  );
}

export default FinalCta;